(function(){
  var COLORS=['sauge','gris perle','camel','cacao','rose poudré'];
  function norm(s){return (s||'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
  var NC=COLORS.map(norm);
  function current(){
    var r=document.querySelector('input[type=radio][name^="Coloris"]:checked');
    if(r) return norm(r.value);
    var s=document.querySelector('select[name^="Coloris"]'); return s?norm(s.value):null;
  }
  var busy=false;
  function apply(){
    var c=current(); if(!c||NC.indexOf(c)<0) return;
    busy=true;
    var sel='slideshow-slide, li.product-media-container, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnail';
    document.querySelectorAll(sel).forEach(function(el){
      var img=el.querySelector('img'); if(!img) return;
      var a=norm(img.alt), has=NC.some(function(x){return a.indexOf(x)>-1;});
      var hide=has && a.indexOf(c)<0;
      if(hide){ if(el.style.display!=='none') el.style.display='none'; el.setAttribute('data-ab-hidden',''); }
      else if(el.hasAttribute('data-ab-hidden')){ el.style.display=''; el.removeAttribute('data-ab-hidden'); }
    });
    document.querySelectorAll('slideshow-component').forEach(function(sc){
      var slides=sc.querySelectorAll('slideshow-slide'), dots=sc.querySelectorAll('.slideshow-controls__dots > li, .slideshow-controls__dots > button');
      if(dots.length===slides.length) dots.forEach(function(d,i){ var h=slides[i].hasAttribute('data-ab-hidden'); if((d.style.display==='none')!==h) d.style.display=h?'none':''; });
    });
    setTimeout(function(){busy=false;},0);
  }
  var t; function later(){ if(busy) return; clearTimeout(t); t=setTimeout(apply,30); }
  document.addEventListener('change',later,true);
  document.addEventListener('variant:update',later);
  new MutationObserver(later).observe(document.body,{childList:true,subtree:true});
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',apply); else apply();
})();
